import classes from './InfoContainer.module.scss';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import { useEffect } from 'react';
import useSlice from '../../../../hooks/useSlice';
import { GAMEMODE, VIEW_COUNT_DURATION } from '../../../../utils/constants';
import useVideoQuizConfig from '../../../../hooks/useVideoQuizConfig';
import { NAME_SOUND_ACTIVE_BANK, useGameSounds } from '@educaplay/core';
import useVideo from '../../../../hooks/useVideo';

function sizeCalc(long) {
    if (long < 3) {
        return "--xl";
    } else if (long < 25) {
        return "--l";
    } else if (long < 51) {
        return "--m";
    } else if (long < 125) {
        return "--s";
    } else {
        return "--xs";
    }
}

export function InfoContainer(props) {
    const { currentQuestion, previousAnswers } = props;
    const { markQuestionViewed, currentQuestionTimeAppear } = useSlice();
    const { progress } = useVideo();
    const size = currentQuestion.info.trim().length;
    const sizeClass = sizeCalc(size);
    const { gameMode } = useVideoQuizConfig();
    const gameSound = useGameSounds();

    const stopPropagation = (e) => {
        e.stopPropagation();
    }

    useEffect(() => {
        if (progress !== currentQuestionTimeAppear || previousAnswers === null) return;
        const timeId = setTimeout(() => {
            markQuestionViewed();
        }, gameMode === GAMEMODE.FREEDOM ? VIEW_COUNT_DURATION : 0)

        return () => {
            clearTimeout(timeId)
        }
    }, [markQuestionViewed, gameMode, progress, currentQuestionTimeAppear, previousAnswers])


    useEffect(() => {
        gameSound.play(NAME_SOUND_ACTIVE_BANK);
    }, [gameSound])

    return (
        <motion.div
            className={clsx(classes.informationcontainer, classes.scrollbar)}
            onClick={stopPropagation}
            initial={{ y: "100%", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: "200%", opacity: 0, transition: { duration: 0.4 } }}
            transition={{ duration: 0.6, delay: 0.3 }}
        >
            <div className={clsx(classes.information, classes[sizeClass])}>
                {currentQuestion.info}
            </div>
        </motion.div>
    )

}

